<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter20">
<h1><a id="page_38"></a><a href="#/003toc#ch20">Greens ’n’ Beans Soup</a></h1>
<p class="noindent">This simple vegetable soup gets its rich flavor from escarole, creamy white beans, and the rind from Parmigiano-Reggiano cheese. Although you can put everything directly into the slow cooker, I recommend the sauté at the beginning to develop the flavors of the onion and garlic.</p>
<p class="noindent">2 tablespoons extra-virgin olive oil</p>
<p class="noindent">1 large sweet onion, coarsely chopped</p>
<p class="noindent">3 stalks celery, coarsely chopped</p>
<p class="noindent">2 carrots, coarsely chopped</p>
<p class="noindent">2 cloves garlic, minced</p>
<p class="noindent">2 heads escarole, tough outer leaves removed, cut into 1-inch pieces (see savvy)</p>
<p class="noindent">2 cups small white beans, picked over for stones, soaked, or two 15-ounce cans small white beans, drained and rinsed (see savvy)</p>
<p class="noindent">4 cups vegetable or chicken broth</p>
<p class="noindent">¼ cup chopped rind from Parmigiano-Reggiano, plus ½ cup freshly grated Parmigiano-Reggiano cheese for garnishing (optional)</p>
<p class="noindent">Freshly ground black pepper</p>
<p class="noindent">Salt</p>
<p class="noindent">heat the oil in a skillet over medium-high heat. Add the onion, celery, and carrots and sauté until the onion begins to soften. Add the garlic and continue to cook for about 2 minutes, until the vegetables are fragrant but not soft.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Top the vegetables with the escarole, stir in the beans, and pour the broth over the escarole. Add the cheese rind (if using) and ½ teaspoon of pepper and stir to combine.</p>
<p class="noindent">cover the slow cooker and cook on low for 4 hours or on high for 2 hours. Remove the cover and season with salt and pepper. serve the soup garnished with freshly grated Parmigiano-Reggiano, if desired.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> bean savvy</p>
<p class="noindent">If you are in a hurry and don’t have time to soak the beans overnight, canned beans will work. Make sure to rinse and drain them in a sieve before adding them to the cooker. </p>
<p class="noindent"><strong>escarole savvy</strong></p>
<p class="noindent">If escarole is pricey or not available, Swiss chard or Savoy cabbage are nice replacements. Chop the chard, including the stems, which will become tender during the long cooking process.</p>
<p class="noindent"><strong>slow-cooker addition</strong></p>
<p class="noindent">Add 2 cups cooked chicken with the other ingredients and proceed as directed.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 026-chapter20.vue?1408693d